import React from 'react';
import PropTypes from 'prop-types';

const Star = (props) => {
  let starIcons = 'fa fa-star';

  if (!props.selected) {
    starIcons += '-o';
  } else if (props.half) {
    starIcons += '-half';
  }

  return (
    <i {...props} className={starIcons} />
  );
};

Star.propTypes = {
  selected: PropTypes.bool,
  half: PropTypes.bool,
};

export default Star;



// WEBPACK FOOTER //
// ./src/client/components/rating/star.jsx